<div>
  <a class="button active" (click)="opened = !opened">{{ name }}&nbsp;&nbsp;<i class="fa fa-chevron-circle-down"></i></a>
  <div *ngIf="opened" class="content-container align-{{ align }}">
    <div class="bordered">
      <ng-content></ng-content>
    </div>
  </div>
</div>
